import React, { Component } from "react";
import { Card, Table, Button, Row, Col, Modal, Form, Alert, Badge } from "react-bootstrap";
import { FaPlus, FaRegEdit, FaTrash, FaCheck, FaEnvelope } from "react-icons/fa";
import api from "../../services/api";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import Editor from '@monaco-editor/react';
import Paginacao from '../../common/pagination';

class ProgramaReguasComunicacao extends Component {
    constructor(props) {
        super(props);

        this.onClickPagina = this.onClickPagina.bind(this);
        this.onClickPaginaMensagens = this.onClickPaginaMensagens.bind(this);

        this.state = {
            // Listagem de Réguas
            listReguas: [],
            loading: true,
            loadingModal: false,
            error: '',
            page_numb: 1,
            
            // Modal Régua
            showModalRegua: false,
            modalReguaTitulo: '',
            reguaEditando: null,
            
            // Campos do formulário Régua
            regua_id: null,
            regua_titulo: '',
            regua_status: 'ativo',
            regua_inicio_modo: 'automatico',
            regua_condicao_inicio_json: '{}',
            
            // Erros de validação Régua
            regua_tituloError: '',
            regua_statusError: '',
            regua_inicio_modoError: '',
            regua_condicao_inicio_jsonError: '',

            // Modal Mensagens
            showModalMensagens: false,
            reguaSelecionada: null,
            listMensagens: [],
            loadingMensagens: true,
            errorMensagens: '',
            page_numb_mensagens: 1,

            // Modal Edição Mensagem
            showModalEditarMensagem: false,
            modalMensagemTitulo: '',
            loadingModalMensagem: false,

            // Campos do formulário Mensagem
            mensagem_id: null,
            mensagem_titulo: '',
            mensagem_tipo_disparo: 'automatico',
            mensagem_atraso_dias: 0,
            mensagem_base_atraso: 'inicio_regua',
            mensagem_template_whatsapp: '',
            mensagem_conteudo_email: '',
            mensagem_ativo: true,
            mensagem_ordem: 0,
            mensagem_anterior_id: '',
            mensagem_condicao_envio_json: '{}',

            // Erros de validação Mensagem
            mensagem_tituloError: '',
            mensagem_tipo_disparoError: '',
            mensagem_atraso_diasError: '',
            mensagem_base_atrasoError: '',
            mensagem_ordemError: '',
            mensagem_condicao_envio_jsonError: '',
        };

        this.statusOptions = [
            { value: 'ativo', label: 'Ativo', variant: 'success' },
            { value: 'pausado', label: 'Pausado', variant: 'warning' },
            { value: 'arquivado', label: 'Arquivado', variant: 'secondary' }
        ];

        this.inicioModoOptions = [
            { value: 'automatico', label: 'Automático' },
            { value: 'manual', label: 'Manual' }
        ];

        this.tipoDisparoOptions = [
            { value: 'automatico', label: 'Automático' },
            { value: 'manual', label: 'Manual' }
        ];

        this.baseAtrasoOptions = [
            { value: 'inicio_regua', label: 'Início da Régua' },
            { value: 'ultima_mensagem', label: 'Última Mensagem' }
        ];
    }

    componentDidMount() {
        this.carregarReguas(this.state.page_numb);
    }

    // ==================== RÉGUAS ====================

    carregarReguas = (page_numb = 1) => {
        const { programaId } = this.props;

        if (!programaId) {
            this.setState({ loading: false, error: 'ID do programa não informado' });
            return;
        }

        this.setState({ loading: true, error: '' });

        api.get(`/programas/reguas-comunicacao/?programa_id=${programaId}&page=${page_numb}`)
            .then(response => {
                this.setState({
                    listReguas: response.data,
                    loading: false,
                    error: '',
                });
            })
            .catch(error => {
                let erro_msg = 'Erro ao carregar réguas de comunicação';

                if (error.response && error.response.status === 500) {
                    erro_msg = 'Servidor indisponível no momento, tente novamente';
                } else if (error.response && error.response.status === 403) {
                    erro_msg = 'Você não tem permissão para acessar essa área';
                }

                this.setState({
                    loading: false,
                    error: erro_msg,
                });
            });
    };

    onClickPagina(num_page) {
        this.setState({
            loading: true,
            page_numb: num_page
        });
        
        this.carregarReguas(num_page);
    }

    gerarResumoJson = (json, maxLength = 60) => {
        if (!json || (Array.isArray(json) && json.length === 0) || (typeof json === 'object' && Object.keys(json).length === 0)) {
            return <span className="text-muted">-</span>;
        }

        try {
            let resumo = '';

            if (Array.isArray(json)) {
                const qtd = json.length;
                const preview = json.slice(0, 2).map(item => {
                    if (typeof item === 'object' && item !== null) {
                        const keys = Object.keys(item).slice(0, 2);
                        return keys.map(k => `${k}: ${this.formatarValor(item[k])}`).join(', ');
                    }
                    return String(item);
                }).join(' | ');

                resumo = `[${qtd}] ${preview}`;
            } else if (typeof json === 'object') {
                const keys = Object.keys(json).slice(0, 3);
                resumo = keys.map(k => `${k}: ${this.formatarValor(json[k])}`).join(', ');
            } else {
                resumo = String(json);
            }

            if (resumo.length > maxLength) {
                resumo = resumo.substring(0, maxLength) + '...';
            }

            return <span title={JSON.stringify(json, null, 2)}>{resumo}</span>;
        } catch (e) {
            return <span className="text-muted">Erro</span>;
        }
    };

    formatarValor = (valor) => {
        if (valor === null || valor === undefined) return 'null';
        if (typeof valor === 'boolean') return valor ? 'true' : 'false';
        if (typeof valor === 'object') return Array.isArray(valor) ? `[${valor.length}]` : '{...}';
        if (typeof valor === 'string' && valor.length > 15) return valor.substring(0, 15) + '...';
        return String(valor);
    };

    abrirModalNovaRegua = () => {
        this.setState({
            showModalRegua: true,
            modalReguaTitulo: 'Adicionar Régua de Comunicação',
            reguaEditando: null,
            regua_id: null,
            regua_titulo: '',
            regua_status: 'ativo',
            regua_inicio_modo: 'automatico',
            regua_condicao_inicio_json: '{}',
            regua_tituloError: '',
            regua_statusError: '',
            regua_inicio_modoError: '',
            regua_condicao_inicio_jsonError: '',
        });
    };

    abrirModalEditarRegua = (regua) => {
        this.setState({
            showModalRegua: true,
            modalReguaTitulo: 'Editar Régua de Comunicação',
            reguaEditando: regua,
            regua_id: regua.id,
            regua_titulo: regua.titulo || '',
            regua_status: regua.status || 'ativo',
            regua_inicio_modo: regua.inicio_modo || 'automatico',
            regua_condicao_inicio_json: regua.condicao_inicio_json ? JSON.stringify(regua.condicao_inicio_json, null, 4) : '{}',
            regua_tituloError: '',
            regua_statusError: '',
            regua_inicio_modoError: '',
            regua_condicao_inicio_jsonError: '',
        });
    };

    fecharModalRegua = () => {
        this.setState({
            showModalRegua: false,
            reguaEditando: null,
        });
    };

    handleChangeRegua = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value, [`${name}Error`]: '' });
    };

    handleCondicaoInicioJsonChange = (value) => {
        this.setState({ regua_condicao_inicio_json: value || '', regua_condicao_inicio_jsonError: '' });
    };

    validarFormularioRegua = () => {
        let valido = true;

        if (!this.state.regua_titulo.trim()) {
            this.setState({ regua_tituloError: 'Título é obrigatório' });
            valido = false;
        }

        if (!this.state.regua_status) {
            this.setState({ regua_statusError: 'Status é obrigatório' });
            valido = false;
        }

        if (!this.state.regua_inicio_modo) {
            this.setState({ regua_inicio_modoError: 'Modo de início é obrigatório' });
            valido = false;
        }

        // Validar JSON se preenchido
        if (this.state.regua_condicao_inicio_json && this.state.regua_condicao_inicio_json.trim() !== '') {
            try {
                JSON.parse(this.state.regua_condicao_inicio_json);
            } catch (e) {
                this.setState({ regua_condicao_inicio_jsonError: 'JSON inválido. Verifique a sintaxe.' });
                valido = false;
            }
        }

        return valido;
    };

    salvarRegua = async () => {
        if (!this.validarFormularioRegua()) {
            return;
        }

        const { programaId } = this.props;
        const { regua_id, regua_titulo, regua_status, regua_inicio_modo, regua_condicao_inicio_json } = this.state;

        this.setState({ loadingModal: true });

        let condicaoJson = null;
        if (regua_condicao_inicio_json && regua_condicao_inicio_json.trim() !== '' && regua_condicao_inicio_json.trim() !== '{}') {
            try {
                condicaoJson = JSON.parse(regua_condicao_inicio_json);
            } catch (e) {
                condicaoJson = null;
            }
        }

        const dados = {
            programa_id: programaId,
            titulo: regua_titulo,
            status: regua_status,
            inicio_modo: regua_inicio_modo,
            condicao_inicio_json: condicaoJson,
        };

        const url = regua_id ? `/programas/reguas-comunicacao/${regua_id}/` : '/programas/reguas-comunicacao/';
        const metodo = regua_id ? 'put' : 'post';

        try {
            await api({
                method: metodo,
                url: url,
                data: dados,
            });

            const MySwal = withReactContent(Swal);
            const textSwal = regua_id ? 'Régua atualizada com sucesso' : 'Régua cadastrada com sucesso';

            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            });

            this.setState({ loadingModal: false });
            this.fecharModalRegua();
            this.carregarReguas(this.state.page_numb);

        } catch (error) {
            let erro_msg = 'Erro ao salvar régua, verifique os campos e tente novamente';

            if (error.response && error.response.status === 500) {
                erro_msg = 'Servidor indisponível no momento';
            } else if (error.response && error.response.status === 400) {
                const campos = error.response.data;
                
                if (campos.titulo) this.setState({ regua_tituloError: campos.titulo });
                if (campos.status) this.setState({ regua_statusError: campos.status });
                if (campos.inicio_modo) this.setState({ regua_inicio_modoError: campos.inicio_modo });
                if (campos.condicao_inicio_json) this.setState({ regua_condicao_inicio_jsonError: campos.condicao_inicio_json });
            }

            const MySwal = withReactContent(Swal);
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
            });

            this.setState({ loadingModal: false });
        }
    };

    excluirRegua = (regua) => {
        const MySwal = withReactContent(Swal);

        MySwal.fire({
            title: 'Você tem certeza?',
            text: 'Todas as mensagens desta régua também serão excluídas!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Sim, excluir!',
            cancelButtonText: 'Cancelar'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await api.delete(`/programas/reguas-comunicacao/${regua.id}/`);

                    MySwal.fire(
                        'Excluído!',
                        'A régua foi excluída com sucesso.',
                        'success'
                    );

                    this.carregarReguas(this.state.page_numb);

                } catch (error) {
                    let erro_msg = 'Erro ao excluir régua';

                    if (error.response && error.response.status === 500) {
                        erro_msg = 'Servidor indisponível no momento';
                    }

                    MySwal.fire({
                        icon: 'error',
                        title: 'Erro',
                        text: erro_msg,
                    });
                }
            }
        });
    };

    getStatusBadge = (status) => {
        const statusObj = this.statusOptions.find(s => s.value === status);
        if (!statusObj) return <Badge bg="secondary">{status}</Badge>;
        return <Badge bg={statusObj.variant}>{statusObj.label}</Badge>;
    };

    renderRowsReguas = () => {
        if ('results' in this.state.listReguas && this.state.listReguas.results.length > 0) {
            return this.state.listReguas.results.map((regua) => (
                <tr key={regua.id}>
                    <td>{regua.id}</td>
                    <td>{regua.titulo}</td>
                    <td>{this.getStatusBadge(regua.status)}</td>
                    <td>
                        <Badge bg={regua.inicio_modo === 'automatico' ? 'primary' : 'info'}>
                            {regua.inicio_modo === 'automatico' ? 'Automático' : 'Manual'}
                        </Badge>
                    </td>
                    <td style={{ maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {this.gerarResumoJson(regua.condicao_inicio_json)}
                    </td>
                    <td>
                        <Button 
                            variant="info" 
                            size="sm" 
                            className="me-1"
                            onClick={() => this.abrirModalMensagens(regua)}
                            title="Gerenciar Mensagens"
                        >
                            <FaEnvelope /> Mensagens
                        </Button>
                        <Button 
                            variant="light" 
                            size="sm" 
                            className="me-1"
                            onClick={() => this.abrirModalEditarRegua(regua)}
                        >
                            <FaRegEdit /> Editar
                        </Button>
                        <Button 
                            variant="danger" 
                            size="sm"
                            onClick={() => this.excluirRegua(regua)}
                        >
                            <FaTrash />
                        </Button>
                    </td>
                </tr>
            ));
        }

        return (
            <tr>
                <td colSpan={6}>Nenhuma régua de comunicação cadastrada para este programa</td>
            </tr>
        );
    };

    // ==================== MENSAGENS ====================

    abrirModalMensagens = (regua) => {
        this.setState({
            showModalMensagens: true,
            reguaSelecionada: regua,
            listMensagens: [],
            loadingMensagens: true,
            page_numb_mensagens: 1,
        }, () => {
            this.carregarMensagens(regua.id, 1);
        });
    };

    fecharModalMensagens = () => {
        this.setState({
            showModalMensagens: false,
            reguaSelecionada: null,
            listMensagens: [],
        });
    };

    carregarMensagens = (regua_id, page_numb = 1) => {
        this.setState({ loadingMensagens: true, errorMensagens: '' });

        api.get(`/programas/reguas-comunicacao/mensagens/?regua_id=${regua_id}&page=${page_numb}`)
            .then(response => {
                this.setState({
                    listMensagens: response.data,
                    loadingMensagens: false,
                    errorMensagens: '',
                });
            })
            .catch(error => {
                let erro_msg = 'Erro ao carregar mensagens';

                if (error.response && error.response.status === 500) {
                    erro_msg = 'Servidor indisponível no momento';
                }

                this.setState({
                    loadingMensagens: false,
                    errorMensagens: erro_msg,
                });
            });
    };

    onClickPaginaMensagens(num_page) {
        this.setState({
            loadingMensagens: true,
            page_numb_mensagens: num_page
        });
        
        this.carregarMensagens(this.state.reguaSelecionada.id, num_page);
    }

    abrirModalNovaMensagem = () => {
        this.setState({
            showModalEditarMensagem: true,
            modalMensagemTitulo: 'Adicionar Mensagem',
            mensagem_id: null,
            mensagem_titulo: '',
            mensagem_tipo_disparo: 'automatico',
            mensagem_atraso_dias: 0,
            mensagem_base_atraso: 'inicio_regua',
            mensagem_template_whatsapp: '',
            mensagem_conteudo_email: '',
            mensagem_ativo: true,
            mensagem_ordem: this.getProximaOrdem(),
            mensagem_anterior_id: '',
            mensagem_condicao_envio_json: '{}',
            mensagem_tituloError: '',
            mensagem_tipo_disparoError: '',
            mensagem_atraso_diasError: '',
            mensagem_base_atrasoError: '',
            mensagem_ordemError: '',
            mensagem_condicao_envio_jsonError: '',
        });
    };

    getProximaOrdem = () => {
        const { listMensagens } = this.state;
        if (!listMensagens.results || listMensagens.results.length === 0) return 1;
        const maxOrdem = Math.max(...listMensagens.results.map(m => m.ordem || 0));
        return maxOrdem + 1;
    };

    abrirModalEditarMensagem = (mensagem) => {
        this.setState({
            showModalEditarMensagem: true,
            modalMensagemTitulo: 'Editar Mensagem',
            mensagem_id: mensagem.id,
            mensagem_titulo: mensagem.titulo || '',
            mensagem_tipo_disparo: mensagem.tipo_disparo || 'automatico',
            mensagem_atraso_dias: mensagem.atraso_dias || 0,
            mensagem_base_atraso: mensagem.base_atraso || 'inicio_regua',
            mensagem_template_whatsapp: mensagem.template_whatsapp || '',
            mensagem_conteudo_email: mensagem.conteudo_email || '',
            mensagem_ativo: mensagem.ativo !== undefined ? mensagem.ativo : true,
            mensagem_ordem: mensagem.ordem || 0,
            mensagem_anterior_id: mensagem.mensagem_anterior_id || '',
            mensagem_condicao_envio_json: mensagem.condicao_envio_json ? JSON.stringify(mensagem.condicao_envio_json, null, 4) : '{}',
            mensagem_tituloError: '',
            mensagem_tipo_disparoError: '',
            mensagem_atraso_diasError: '',
            mensagem_base_atrasoError: '',
            mensagem_ordemError: '',
            mensagem_condicao_envio_jsonError: '',
        });
    };

    fecharModalEditarMensagem = () => {
        this.setState({
            showModalEditarMensagem: false,
        });
    };

    handleChangeMensagem = (e) => {
        const { name, value, type, checked } = e.target;
        const newValue = type === 'checkbox' ? checked : value;
        this.setState({ [name]: newValue });
    };

    handleConteudoEmailChange = (value) => {
        this.setState({ mensagem_conteudo_email: value });
    };

    handleCondicaoEnvioJsonChange = (value) => {
        this.setState({ mensagem_condicao_envio_json: value || '', mensagem_condicao_envio_jsonError: '' });
    };

    validarFormularioMensagem = () => {
        let valido = true;

        if (!this.state.mensagem_titulo.trim()) {
            this.setState({ mensagem_tituloError: 'Título é obrigatório' });
            valido = false;
        }

        if (this.state.mensagem_condicao_envio_json && this.state.mensagem_condicao_envio_json.trim() !== '') {
            try {
                JSON.parse(this.state.mensagem_condicao_envio_json);
            } catch (e) {
                this.setState({ mensagem_condicao_envio_jsonError: 'JSON inválido. Verifique a sintaxe.' });
                valido = false;
            }
        }

        return valido;
    };

    salvarMensagem = async () => {
        if (!this.validarFormularioMensagem()) {
            return;
        }

        const { reguaSelecionada } = this.state;

        this.setState({ loadingModalMensagem: true });

        let condicaoJson = null;
        if (this.state.mensagem_condicao_envio_json && this.state.mensagem_condicao_envio_json.trim() !== '' && this.state.mensagem_condicao_envio_json.trim() !== '{}') {
            try {
                condicaoJson = JSON.parse(this.state.mensagem_condicao_envio_json);
            } catch (e) {
                condicaoJson = null;
            }
        }

        const dados = {
            regua_id: reguaSelecionada.id,
            titulo: this.state.mensagem_titulo,
            tipo_disparo: this.state.mensagem_tipo_disparo,
            atraso_dias: parseInt(this.state.mensagem_atraso_dias) || 0,
            base_atraso: this.state.mensagem_base_atraso,
            template_whatsapp: this.state.mensagem_template_whatsapp,
            ativo: this.state.mensagem_ativo,
            ordem: parseInt(this.state.mensagem_ordem) || 0,
        };

        if(condicaoJson) {
            dados['condicao_envio_json'] = condicao_envio_json;
        }

        if(this.state.mensagem_anterior_id) {
            dados['mensagem_anterior_id'] = this.state.mensagem_anterior_id;
        }

        if(this.state.conteudo_email) {
            dados['conteudo_email'] = this.state.conteudo_email;
        }

        const url = this.state.mensagem_id 
            ? `/programas/reguas-comunicacao/mensagens/${this.state.mensagem_id}/` 
            : '/programas/reguas-comunicacao/mensagens/';
        const metodo = this.state.mensagem_id ? 'put' : 'post';

        try {
            await api({
                method: metodo,
                url: url,
                data: dados,
            });

            const MySwal = withReactContent(Swal);
            const textSwal = this.state.mensagem_id ? 'Mensagem atualizada com sucesso' : 'Mensagem cadastrada com sucesso';

            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            });

            this.setState({ loadingModalMensagem: false });
            this.fecharModalEditarMensagem();
            this.carregarMensagens(reguaSelecionada.id, this.state.page_numb_mensagens);

        } catch (error) {
            let erro_msg = 'Erro ao salvar mensagem, verifique os campos e tente novamente';

            if (error.response && error.response.status === 500) {
                erro_msg = 'Servidor indisponível no momento';
            } else if (error.response && error.response.status === 400) {
                const campos = error.response.data;
                
                if (campos.titulo) this.setState({ mensagem_tituloError: campos.titulo });
                if (campos.tipo_disparo) this.setState({ mensagem_tipo_disparoError: campos.tipo_disparo });
                if (campos.atraso_dias) this.setState({ mensagem_atraso_diasError: campos.atraso_dias });
                if (campos.base_atraso) this.setState({ mensagem_base_atrasoError: campos.base_atraso });
                if (campos.ordem) this.setState({ mensagem_ordemError: campos.ordem });
                if (campos.condicao_envio_json) this.setState({ mensagem_condicao_envio_jsonError: campos.condicao_envio_json });
            }

            const MySwal = withReactContent(Swal);
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
            });

            this.setState({ loadingModalMensagem: false });
        }
    };

    excluirMensagem = (mensagem) => {
        const MySwal = withReactContent(Swal);

        MySwal.fire({
            title: 'Você tem certeza?',
            text: 'Esta ação não pode ser desfeita!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Sim, excluir!',
            cancelButtonText: 'Cancelar'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await api.delete(`/programas/reguas-comunicacao/mensagens/${mensagem.id}/`);

                    MySwal.fire(
                        'Excluído!',
                        'A mensagem foi excluída com sucesso.',
                        'success'
                    );

                    this.carregarMensagens(this.state.reguaSelecionada.id, this.state.page_numb_mensagens);

                } catch (error) {
                    let erro_msg = 'Erro ao excluir mensagem';

                    if (error.response && error.response.status === 500) {
                        erro_msg = 'Servidor indisponível no momento';
                    }

                    MySwal.fire({
                        icon: 'error',
                        title: 'Erro',
                        text: erro_msg,
                    });
                }
            }
        });
    };

    getMensagemAnteriorNome = (mensagem_anterior_id) => {
        const { listMensagens } = this.state;
        if (!mensagem_anterior_id || !listMensagens.results) return '-';
        const mensagem = listMensagens.results.find(m => m.id === mensagem_anterior_id);
        return mensagem ? mensagem.titulo : '-';
    };

    renderRowsMensagens = () => {
        const { listMensagens, loadingMensagens, errorMensagens } = this.state;

        if (loadingMensagens) {
            return (
                <tr>
                    <td colSpan={7}>Carregando...</td>
                </tr>
            );
        }

        if (errorMensagens) {
            return (
                <tr>
                    <td colSpan={7}>{errorMensagens}</td>
                </tr>
            );
        }

        if ('results' in listMensagens && listMensagens.results.length > 0) {
            return listMensagens.results.map((mensagem) => (
                <tr key={mensagem.id}>
                    <td>{mensagem.ordem}</td>
                    <td>{mensagem.titulo}</td>
                    <td>
                        <Badge bg={mensagem.tipo_disparo === 'automatico' ? 'primary' : 'info'}>
                            {mensagem.tipo_disparo === 'automatico' ? 'Automático' : 'Manual'}
                        </Badge>
                    </td>
                    <td>{mensagem.atraso_dias} dias</td>
                    <td>
                        <Badge bg={mensagem.ativo ? 'success' : 'secondary'}>
                            {mensagem.ativo ? 'Ativo' : 'Inativo'}
                        </Badge>
                    </td>
                    <td>
                        <Button 
                            variant="light" 
                            size="sm" 
                            className="me-1"
                            onClick={() => this.abrirModalEditarMensagem(mensagem)}
                        >
                            <FaRegEdit /> Editar
                        </Button>
                        <Button 
                            variant="danger" 
                            size="sm"
                            onClick={() => this.excluirMensagem(mensagem)}
                        >
                            <FaTrash />
                        </Button>
                    </td>
                </tr>
            ));
        }

        return (
            <tr>
                <td colSpan={7}>Nenhuma mensagem cadastrada para esta régua</td>
            </tr>
        );
    };

    // ==================== RENDER ====================

    render() {
        const { 
            loading, 
            loadingModal,
            error, 
            listReguas,
            page_numb,
            // Modal Régua
            showModalRegua,
            modalReguaTitulo,
            regua_titulo,
            regua_status,
            regua_inicio_modo,
            regua_condicao_inicio_json,
            regua_tituloError,
            regua_statusError,
            regua_inicio_modoError,
            regua_condicao_inicio_jsonError,
            // Modal Mensagens
            showModalMensagens,
            reguaSelecionada,
            listMensagens,
            loadingMensagens,
            page_numb_mensagens,
            // Modal Editar Mensagem
            showModalEditarMensagem,
            modalMensagemTitulo,
            loadingModalMensagem,
            mensagem_titulo,
            mensagem_tipo_disparo,
            mensagem_atraso_dias,
            mensagem_base_atraso,
            mensagem_template_whatsapp,
            mensagem_conteudo_email,
            mensagem_ativo,
            mensagem_ordem,
            mensagem_anterior_id,
            mensagem_condicao_envio_json,
            mensagem_tituloError,
            mensagem_atraso_diasError,
            mensagem_ordemError,
            mensagem_condicao_envio_jsonError,
        } = this.state;

        return (
            <>
                <Card className="cardDestaque">
                    <Card.Body>
                        <Row className="align-items-center mb-3">
                            <Col sm={6} lg={6}>
                                <h4>Réguas de Comunicação</h4>
                            </Col>
                            <Col sm={6} lg={6} className="text-end">
                                <Button variant="secondary" size="sm" onClick={this.abrirModalNovaRegua}>
                                    <FaPlus /> Adicionar Régua
                                </Button>
                            </Col>
                        </Row>

                        <Table responsive className="custom-table">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Título</th>
                                    <th>Status</th>
                                    <th>Início</th>
                                    <th>Condição</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr>
                                        <td colSpan={6}>Carregando...</td>
                                    </tr>
                                ) : (
                                    error ? (
                                        <tr>
                                            <td colSpan={6}>{error}</td>
                                        </tr>
                                    ) : this.renderRowsReguas()
                                )}
                            </tbody>
                        </Table>

                        {'results' in listReguas && listReguas.results.length > 0 && 
                            <Paginacao 
                                dados={listReguas} 
                                loading={loading} 
                                page_numb={page_numb} 
                                _onClickPagina={this.onClickPagina} 
                            />
                        }
                    </Card.Body>
                </Card>

                {/* Modal Cadastro/Edição de Régua */}
                <Modal 
                    show={showModalRegua} 
                    onHide={this.fecharModalRegua}
                    size="lg"
                    backdrop="static"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>{modalReguaTitulo}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            <Row>
                                <Col sm={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Título <span style={{ color: 'red' }}>*</span></Form.Label>
                                        <Form.Control 
                                            type="text" 
                                            name="regua_titulo"
                                            value={regua_titulo}
                                            onChange={this.handleChangeRegua}
                                            placeholder="Título da régua"
                                        />
                                        {regua_tituloError && (
                                            <Form.Text className="text-danger">{regua_tituloError}</Form.Text>
                                        )}
                                    </Form.Group>
                                </Col>
                                <Col sm={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Status <span style={{ color: 'red' }}>*</span></Form.Label>
                                        <Form.Control 
                                            as="select" 
                                            name="regua_status"
                                            value={regua_status}
                                            onChange={this.handleChangeRegua}
                                        >
                                            {this.statusOptions.map(opt => (
                                                <option key={opt.value} value={opt.value}>{opt.label}</option>
                                            ))}
                                        </Form.Control>
                                        {regua_statusError && (
                                            <Form.Text className="text-danger">{regua_statusError}</Form.Text>
                                        )}
                                    </Form.Group>
                                </Col>
                                <Col sm={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Modo de Início <span style={{ color: 'red' }}>*</span></Form.Label>
                                        <Form.Control 
                                            as="select" 
                                            name="regua_inicio_modo"
                                            value={regua_inicio_modo}
                                            onChange={this.handleChangeRegua}
                                        >
                                            {this.inicioModoOptions.map(opt => (
                                                <option key={opt.value} value={opt.value}>{opt.label}</option>
                                            ))}
                                        </Form.Control>
                                        {regua_inicio_modoError && (
                                            <Form.Text className="text-danger">{regua_inicio_modoError}</Form.Text>
                                        )}
                                    </Form.Group>
                                </Col>
                                <Col sm={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Condição de Início (JSON)</Form.Label>
                                        {regua_condicao_inicio_jsonError && (
                                            <Alert variant="danger" className="py-1 mb-2">{regua_condicao_inicio_jsonError}</Alert>
                                        )}
                                        <Editor
                                            height="150px"
                                            defaultLanguage="json"
                                            value={regua_condicao_inicio_json}
                                            onChange={this.handleCondicaoInicioJsonChange}
                                            theme="vs-dark"
                                            options={{
                                                minimap: { enabled: false },
                                                fontSize: 14,
                                                formatOnPaste: true,
                                                formatOnType: true,
                                                automaticLayout: true,
                                                tabSize: 4,
                                            }}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.fecharModalRegua}>
                            Cancelar
                        </Button>
                        <Button 
                            variant="success" 
                            onClick={this.salvarRegua}
                            disabled={loadingModal}
                        >
                            {loadingModal ? (
                                <span className="spinner-border spinner-border-sm"></span>
                            ) : (
                                <>
                                    <FaCheck className="me-1" /> Salvar
                                </>
                            )}
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* Modal Listagem de Mensagens */}
                <Modal 
                    show={showModalMensagens} 
                    onHide={this.fecharModalMensagens}
                    size="xl"
                    backdrop="static"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>
                            Mensagens da Régua: {reguaSelecionada?.titulo}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Row className="align-items-center mb-3">
                            <Col sm={6}>
                                <h5>Mensagens Configuradas</h5>
                            </Col>
                            <Col sm={6} className="text-end">
                                <Button variant="primary" size="sm" onClick={this.abrirModalNovaMensagem}>
                                    <FaPlus /> Adicionar Mensagem
                                </Button>
                            </Col>
                        </Row>

                        <Table responsive className="custom-table">
                            <thead>
                                <tr>
                                    <th>Ordem</th>
                                    <th>Título</th>
                                    <th>Tipo Disparo</th>
                                    <th>Atraso</th>
                                    <th>Status</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.renderRowsMensagens()}
                            </tbody>
                        </Table>

                        {'results' in listMensagens && listMensagens.results.length > 0 && 
                            <Paginacao 
                                dados={listMensagens} 
                                loading={loadingMensagens} 
                                page_numb={page_numb_mensagens} 
                                _onClickPagina={this.onClickPaginaMensagens} 
                            />
                        }
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.fecharModalMensagens}>
                            Fechar
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* Modal Edição de Mensagem */}
                <Modal 
                    show={showModalEditarMensagem} 
                    onHide={this.fecharModalEditarMensagem}
                    size="xl"
                    backdrop="static"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>{modalMensagemTitulo}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form>
                            <Row>
                                <Col sm={8}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Título <span style={{ color: 'red' }}>*</span></Form.Label>
                                        <Form.Control 
                                            type="text" 
                                            name="mensagem_titulo"
                                            value={mensagem_titulo}
                                            onChange={this.handleChangeMensagem}
                                            placeholder="Título da mensagem"
                                        />
                                        {mensagem_tituloError && (
                                            <Form.Text className="text-danger">{mensagem_tituloError}</Form.Text>
                                        )}
                                    </Form.Group>
                                </Col>
                                <Col sm={2}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Ordem</Form.Label>
                                        <Form.Control 
                                            type="number" 
                                            name="mensagem_ordem"
                                            value={mensagem_ordem}
                                            onChange={this.handleChangeMensagem}
                                        />
                                        {mensagem_ordemError && (
                                            <Form.Text className="text-danger">{mensagem_ordemError}</Form.Text>
                                        )}
                                    </Form.Group>
                                </Col>
                                <Col sm={2}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Ativo</Form.Label>
                                        <Form.Check
                                            type="checkbox"
                                            name="mensagem_ativo"
                                            checked={mensagem_ativo}
                                            onChange={this.handleChangeMensagem}
                                            label="Sim"
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm={3}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Tipo de Disparo</Form.Label>
                                        <Form.Control 
                                            as="select" 
                                            name="mensagem_tipo_disparo"
                                            value={mensagem_tipo_disparo}
                                            onChange={this.handleChangeMensagem}
                                        >
                                            {this.tipoDisparoOptions.map(opt => (
                                                <option key={opt.value} value={opt.value}>{opt.label}</option>
                                            ))}
                                        </Form.Control>
                                    </Form.Group>
                                </Col>
                                <Col sm={3}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Atraso (dias)</Form.Label>
                                        <Form.Control 
                                            type="number" 
                                            name="mensagem_atraso_dias"
                                            value={mensagem_atraso_dias}
                                            onChange={this.handleChangeMensagem}
                                            min="0"
                                        />
                                        {mensagem_atraso_diasError && (
                                            <Form.Text className="text-danger">{mensagem_atraso_diasError}</Form.Text>
                                        )}
                                    </Form.Group>
                                </Col>
                                <Col sm={3}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Base do Atraso</Form.Label>
                                        <Form.Control 
                                            as="select" 
                                            name="mensagem_base_atraso"
                                            value={mensagem_base_atraso}
                                            onChange={this.handleChangeMensagem}
                                        >
                                            {this.baseAtrasoOptions.map(opt => (
                                                <option key={opt.value} value={opt.value}>{opt.label}</option>
                                            ))}
                                        </Form.Control>
                                    </Form.Group>
                                </Col>
                                <Col sm={3}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Mensagem Anterior</Form.Label>
                                        <Form.Control 
                                            as="select" 
                                            name="mensagem_anterior_id"
                                            value={mensagem_anterior_id}
                                            onChange={this.handleChangeMensagem}
                                        >
                                            <option value="">Nenhuma</option>
                                            {listMensagens.results && listMensagens.results
                                                .filter(m => m.id !== this.state.mensagem_id)
                                                .map(m => (
                                                    <option key={m.id} value={m.id}>{m.titulo}</option>
                                                ))
                                            }
                                        </Form.Control>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Template WhatsApp</Form.Label>
                                        <Form.Control 
                                            type="text" 
                                            name="mensagem_template_whatsapp"
                                            value={mensagem_template_whatsapp}
                                            onChange={this.handleChangeMensagem}
                                            placeholder="Nome do template do WhatsApp"
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Conteúdo do E-mail (HTML)</Form.Label>
                                        <Editor
                                            height="200px"
                                            defaultLanguage="html"
                                            value={mensagem_conteudo_email}
                                            onChange={this.handleConteudoEmailChange}
                                            theme="vs-dark"
                                            options={{
                                                minimap: { enabled: false },
                                                fontSize: 14,
                                                formatOnPaste: true,
                                                formatOnType: true,
                                                automaticLayout: true,
                                                tabSize: 4,
                                                wordWrap: 'on',
                                            }}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col sm={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Condição de Envio (JSON)</Form.Label>
                                        {mensagem_condicao_envio_jsonError && (
                                            <Alert variant="danger" className="py-1 mb-2">{mensagem_condicao_envio_jsonError}</Alert>
                                        )}
                                        <Editor
                                            height="150px"
                                            defaultLanguage="json"
                                            value={mensagem_condicao_envio_json}
                                            onChange={this.handleCondicaoEnvioJsonChange}
                                            theme="vs-dark"
                                            options={{
                                                minimap: { enabled: false },
                                                fontSize: 14,
                                                formatOnPaste: true,
                                                formatOnType: true,
                                                automaticLayout: true,
                                                tabSize: 4,
                                            }}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.fecharModalEditarMensagem}>
                            Cancelar
                        </Button>
                        <Button 
                            variant="success" 
                            onClick={this.salvarMensagem}
                            disabled={loadingModalMensagem}
                        >
                            {loadingModalMensagem ? (
                                <span className="spinner-border spinner-border-sm"></span>
                            ) : (
                                <>
                                    <FaCheck className="me-1" /> Salvar
                                </>
                            )}
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}

export default ProgramaReguasComunicacao;
